// extracted by mini-css-extract-plugin
export default {"wrapper":"EditPost_wrapper__5CXoH","create-post":"EditPost_create-post__YSMOz","form-group":"EditPost_form-group__MrUPG","image-preview":"EditPost_image-preview__+WUsJ"};